import { useMutation } from '..';
import permissions from '../Apollo/permissions';
import { mutation, buildVariables } from './create-webhook-config-mutation-builder';
import { QUERY_WEBHOOK_CONFIG } from './query-webhook-config-builder';

export default function useCreateWebhookConfig({ onCompleted, ...options } = {}) {
  const [executeMutation, response] = useMutation(mutation, {
    context: { permission: permissions.createWebhookConfig },
    successMsg: 'Webhook Configuration created.',
    refetchQueries: [{ query: QUERY_WEBHOOK_CONFIG }],
    onCompleted: data => {
      if (onCompleted) onCompleted(data.create_webhook_config);
    },
    ...options,
  });

  const createWebhookConfig = ({ url, eventTypes, enabled = true }) =>
    executeMutation({ variables: buildVariables({ url, eventTypes, enabled }) });

  return [createWebhookConfig, response];
}
